/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Deleted_SuccessInputs */



/**
* | output |
* | --- |
* | "Issue deleted successfully" |
*
* @param {Manual_Qc_Deleted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_deleted_success = /** @type {((inputs?: Manual_Qc_Deleted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Deleted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Incident supprime avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Problem erfolgreich gelöscht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Problema eliminato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проблема успешно удалена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Problema eliminado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("问题已成功删除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("問題は正常に削除されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समस्या सफलतापूर्वक हटा दी गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Problema resolvido com sucesso")
	return /** @type {LocalizedString} */ ("Issue deleted successfully")
});